import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=ef73617e&scoped=true"
import script from "./Private.vue?vue&type=script&lang=js"
export * from "./Private.vue?vue&type=script&lang=js"
import style0 from "./Private.vue?vue&type=style&index=0&id=ef73617e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef73617e",
  null
  
)

export default component.exports